<template>
  <div class="account">
    <div class="account_infomation">
      <div class="picture">
        <img
          :src="accountInfo.headimgurl"
          @click="$router.push({ path: '/accountInfo' })"
        />
      </div>
      <div class="account_info">
        <div>
          {{ accountInfo.realName || accountInfo.nickname }}
        </div>
        <img :src="accountInfo.levelImg" v-if="accountInfo.levelImg" />
        <div class="account_defaultVip" v-else>普通会员</div>
      </div>
    </div>
    <div class="account_tab">
      <div
        class="account_item"
        @click="$router.push({ path: '/amonutDetail' })"
      >
        <div>{{ accountInfo.userAmonut ? accountInfo.userAmonut : 0 }}</div>
        <div>我的余额</div>
      </div>
      <div class="account_item" @click="$router.push({ path: '/pointDetail' })">
        <div>{{ accountInfo.userPoints ? accountInfo.userPoints : 0 }}</div>
        <div>我的积分</div>
      </div>
      <div class="account_item" @click="$router.push({ path: '/myBusiness' })">
        <div>
          {{
            accountInfo.purchasedBusinessNum
              ? accountInfo.purchasedBusinessNum
              : 0
          }}
        </div>
        <div>我的商机</div>
      </div>
    </div>
    <div class="account_btn" v-if="$route.name != 'accountInfo'">
      <div @click="$router.push({ path: '/accountInfo' })">
        <i class="el-icon-setting" />
        设置
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    path: {
      type: String,
      default: 'vip',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    ...mapState(['accountInfo']),
  },
}
</script>
<style lang="scss" scoped>
.account {
  position: relative;
  padding-bottom: 65px;
  // 账户信息
  .account_infomation {
    display: flex;
    background-image: url('@/assets/images/account/bgc.png');
    background-size: 110% 110%;
    background-position: -10px;
    padding: 25px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    // 头像
    .picture {
      margin-right: 20px;
      width: 65px;
      height: 65px;
      margin-bottom: 5px;
      background-color: #fff;
      overflow: hidden;
      border-radius: 50%;
      box-shadow: 0 0 5px 2px #fff;
      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }
    // 信息
    .account_info {
      margin-bottom: 5px;
      > div {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        color: #fff;
        font-weight: 600;
        margin: 5px 0;
      }
      img {
        height: 18px;
        border-radius: 5px;
      }
    }
    .account_defaultVip {
      height: 18px !important;
      line-height: 18px !important;
      font-size: 10px !important;
      background: rgba(49, 50, 94, 0.8);
      padding: 0 10px !important;
      text-align: center;
      border-radius: 2px;
      letter-spacing: 2px;
    }
  }
  // 跳转tab
  .account_tab {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
    left: 3%;
    height: 80px;
    background-color: #fff;
    width: 94%;
    bottom: 0;
    border-radius: 5px;
    .account_item {
      text-align: center;
      > div {
        font-size: 14px;
        font-weight: 600;
        margin: 5px;
        color: var(--color_defaultText);
      }
    }
  }
  // 设置
  .account_btn {
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 2px 7px;
    border-radius: 2px;
    background-color: rgba(000, 000, 000, 0.3);
    color: #fff;
    > div {
      display: flex;
      align-items: center;
      font-size: 10px;
      i {
        margin-right: 2px;
        font-size: 10px;
      }
    }
  }
}
</style>
